// extracted by mini-css-extract-plugin
export default {"head":"NewOrganizationPage_head__SdUlJ","title":"NewOrganizationPage_title__3eD6r"};